const tables = [
  {
    name: "Name",
  },
  {
    name: "Role",
  },
  {
    name: "Email",
  },
  {
    name: "Phone",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
